import React from "react";
import groovyWalkAnimation from "../../public/icons/mobilVillaaraAnimation.json";
import dynamic from "next/dynamic";
import { useIntersectionObserver } from "@/hooks/useIntersectionObserver";

const Lottie = dynamic(() => import("lottie-light-react"), {
  ssr: false,
});

export default function AnimatedIcon() {
  const [sectionRef, isVisible] = useIntersectionObserver();
  return (
    <div ref={sectionRef} className="w-12 h-12">
      {isVisible && <Lottie animationData={groovyWalkAnimation} loop={true} />}
    </div>
  );
}
